import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const apiUrl = `${baseApiUrl}/api/criticalsituation`;

export async function getCriticalSituations(data) {
    return await httpRequest(fetchCriticalSituations.bind(this, data));
}
async function fetchCriticalSituations(data) {
    let config = getHttpHeaders();
    let url = `${apiUrl}?PageNumber=${data.pageNumber}&PageSize=${data.pageSize}&`;
    if (data.employeeId !== undefined) {
        url += `employeeId=${data.employeeId}&`
    }
    if (data.statusId !== undefined) {
        url += `statusId=${data.statusId}&`
    }
    if (data.managerId !== undefined) {
        url += `managerId=${data.managerId}&`
    }
    if (data.orderBy !== undefined) {
        url += `orderBy=${data.orderBy}&`
    }
    return await axios.get(`${url}`, config);
}

export async function getCriticalSituation(id) {
    return await httpRequest(getCriticalSituationById.bind(this, id));
}
async function getCriticalSituationById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${apiUrl}/${id}`, config);
}

export async function addCriticalSituation(data) {
    return await httpRequest(postCriticalSituation.bind(this, data));
}
async function postCriticalSituation(data) {
    let config = getHttpHeaders();
    return await axios.post(`${apiUrl}`, data, config);
}

export async function updateCriticalSituation(data) {
    return await httpRequest(putCriticalSituation.bind(this, data));
}
async function putCriticalSituation(data) {
    let config = getHttpHeaders();
    return await axios.put(`${apiUrl}`, data, config);
}

export async function closeCriticalSituation(id) {
    return await httpRequest(deleteCriticalSituation.bind(this, id));
}
async function deleteCriticalSituation(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${apiUrl}/${id}`, config);
}
